
















import Vue from 'vue';
//import ContentAd from '@/components/Sidebar/ContentAd.vue'
import NewsItem from '@/components/Sidebar/NewsItem.vue';

type NewsItemType = {
  id: number;
  image: string;
  url: Array<string>;
  title: string;
};

export default Vue.extend({
  name: 'Sidebar',
  components: {
    //ContentAd,
    NewsItem,
  },
  data() {
    return {
      maxItems: this.num || 5,
    };
  },
  props: ['num'],
  created() {
    this.$store.dispatch('loadRSS');
  },
  computed: {
    newsitems: function(): Array<NewsItemType> {
      return this.$store.state.newsitems.slice(0, this.maxItems);
    },
    advertorials: function(): Array<NewsItemType> {
      return [];
    },
    /*
advertorials: function(): Array<NewsItemType> {
      return [{ id: 0, image: 'https://media.kleinezeitung.at/images/uploads/5/a/0/5973408/aufmacherraiffkl_1619770714796303_v0_h.jpg', url: 'https://www.kleinezeitung.at/advertorials/5973408/', title: 'Gutes tun für sich und andere' }];
    },
    */
  },
});
